import React from "react";
import { Badge } from "primereact/badge";
import { Button } from "primereact/button";

interface SectionHeaderProps {
    title: string;
    index: number;
    isExpanded: boolean;
    wordDifference: {
        difference: number;
        type: 'added' | 'removed' | 'same';
    };
    onToggle: () => void;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
    title,
    index,
    isExpanded,
    wordDifference,
    onToggle
}) => {
    return (
        <div key={title+index} className="flex align-items-center justify-content-between w-full cursor-pointer" onClick={onToggle}>
            <div className="flex align-items-center gap-3">
                <h3 className="m-0 text-primary">{title}</h3>
                <div className="flex gap-2">
                    {wordDifference.type === 'added' && (
                        <Badge 
                            value={`AI added ${wordDifference.difference} words`} 
                            severity="success" 
                            className="text-xs"
                        />
                    )}
                    {wordDifference.type === 'removed' && (
                        <Badge 
                            value={`AI removed ${wordDifference.difference} words`} 
                            severity="warning" 
                            className="text-xs"
                        />
                    )}
                    {wordDifference.type === 'same' && (
                        <Badge 
                            value={`Same word count`} 
                            severity="info" 
                            className="text-xs"
                        />
                    )}
                </div>
            </div>
            <div className="flex align-items-center gap-2">
                <Button
                    icon={isExpanded ? "pi pi-chevron-up" : "pi pi-chevron-down"}
                    className="p-button-text p-button-sm"
                    onClick={(e) => {
                        e.stopPropagation();
                        onToggle();
                    }}
                    tooltip={isExpanded ? "Collapse" : "Expand"}
                    tooltipOptions={{ position: 'left', showDelay: 500 }}
                />
            </div>
        </div>
    );
};